var map = {
	"./1.png": 6266,
	"./2.jpg": 1209,
	"./3.png": 8568,
	"./4.jpg": 2263,
	"./5.jpg": 1098,
	"./6.jpg": 8949,
	"./7.jpg": 1336,
	"./8.jpg": 4099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8051;